import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Field } from "formik";
import { GetProductCategory, Alerts, GetProducts } from "../../../helpers";
import CKEditorField from "../../../components/cmp/CKEditorField";
import Select from "react-select";
import MediaLibraryPopup from "../../../components/cmp/MediaLibraryPopup";
import { FiEdit } from "react-icons/fi";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
const breadcrumbs = [
    {
        id: 1,
        label: "Dashboard",
        link: "/",
    },
    {
        id: 2,
        label: "Categories",
        link: "/app/product/categories",
    },
    {
        id: 3,
        label: "Create New",
        link: "/app/product/categories/create",
    },
];

const flavors = [
    {
        id: 1,
        label: 'Black Forest',
        value: 'Black Forest'
    },
    {
        id: 2,
        label: 'Butterscotch',
        value: 'Butterscotch'
    },
    {
        id: 3,
        label: 'Chocolate',
        value: 'Chocolate'
    },
    {
        id: 4,
        label: 'Fruit Cakes',
        value: 'Fruit Cakes'
    },
    {
        id: 5,
        label: 'Pineapple',
        value: 'Pineapple'
    },
    {
        id: 6,
        label: 'Red Velvet',
        value: 'Red Velvet'
    },
    {
        id: 7,
        label: 'Coffee Cakes',
        value: 'Coffee Cakes'
    },
    {
        id: 8,
        label: 'Strawberry',
        value: 'Strawberry'
    },
    {
        id: 9,
        label: 'KitKat Cakes',
        value: 'KitKat Cakes'
    },
    {
        id: 10,
        label: 'Mango Cake',
        value: 'Mango Cake'
    },
    {
        id: 11,
        label: 'Vanilla',
        value: 'Vanilla'
    },
    {
        id: 12,
        label: 'Truffle Cake',
        value: 'Truffle Cake'
    },
    {
        id: 13,
        label: 'White Forest',
        value: 'White Forest'
    },
    {
        id: 14,
        label: 'Fresh Fruit',
        value: 'Fresh Fruit'
    },
    {
        id: 15,
        label: 'Caramel',
        value: 'Caramel'
    },
    {
        id: 16,
        label: 'Oreo',
        value: 'Oreo'
    },
    {
        id: 17,
        label: 'Coffee',
        value: 'Coffee'
    },
    {
        id: 18,
        label: 'Walnut',
        value: 'Walnut'
    },
]


const CreateProduct = () => {
    const navigate = useNavigate();
    const [categoryOptions, setCategoriesOption] = useState([]);
    const [showMedia, setShowMedia] = useState(false);
    const [product_thumb, setProductThumb] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [product, setProduct] = useState(null);
    const getCategories = async () => {
        let resp = await GetProductCategory.getAllCategories();
        if (resp && resp.status) {

            const optionsValue = resp.data.map(item => ({
                value: item.id,
                label: item.title
            }));
            setCategoriesOption(optionsValue);
        }
    };

    useEffect(() => {
        getCategories();
    }, []);

    // const handleSelectImage = (image) => {
    //     setProductThumb(image);
    //     setShowMedia(false);
    // }





    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        const data = {
            title: values.title,
            short_description: values.short_description,
            description: values.description,
            specification: values.specification,
            regular_price: values.regular_price || 0.00,
            sale_price: values.sale_price || 0.00,
            tax_status: values.tax_status,
            best_seller: values.best_seller ? 1 : 0,
            featured_product: values.featured_product ? 1 : 0,
            flavor:values.flavor,                                      
            sku: values.sku,
            stock: values.stock || 0,
            product_image: values.product_image,
            status: values.status,
            isVariation: values.isVariation ? 1 : 0,
            variation_image: values.variation_image ? 1 : 0,
            isBulk: values.isBulk ? 1 : 0,
            isAddon: values.isAddon ? 1 : 0,
            half_truck_space: values.half_truck_space,
            half_truck_price: values.half_truck_price,
            full_truck_space: values.full_truck_space,
            full_truck_price: values.full_truck_price,
            meta_title: values.meta_title,
            meta_description: values.meta_description,
            meta_keywords: values.meta_keywords,
            canonical_url: values.canonical_url,
            robots: values.robots,
            og_title: values.og_title,
            og_description: values.og_description,
            og_image: values.og_image,
            twitter_title: values.twitter_title,
            twitter_description: values.twitter_description,
            twitter_image: values.twitter_image,
            categories: values.categories
        }

        let resp = await GetProducts.createProduct(data);
        if (resp && resp.status) {
            resetForm();
            Alerts.alertMessage(resp.message, "top-right", "success");
            navigate(`/app/products/manage/${resp.product_id}`);
        } else {
            Alerts.alertMessage(resp.message, "top-right", "error");
        }

        setSubmitting(false);
    };

    return (
        <>

            <div className="innerPageWrapper">
                <div className="container-fluid">
                    <div className="page-title">
                        <h2>
                            <BiCategory /> Create Product
                        </h2>
                        <Link to="/app/products" className="btn btn-success">
                            <BiCategory /> Products
                        </Link>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <Tabs
                                defaultActiveKey="product_details"
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                <Tab eventKey="product_details" title="Product Details">
                                    <Formik
                                        initialValues={{
                                            title: "",
                                            short_description: "",
                                            description: "",
                                            specification: "",
                                            regular_price: "",
                                            sale_price: "",
                                            tax_status: 0,
                                            best_seller: false,
                                            flavor:'',
                                            featured_product:false,
                                            sku: "",
                                            stock: "",
                                            product_image: "",
                                            status: 0,
                                            categories: [],
                                            isVariation: false,
                                            variation_image: false,
                                            isBulk: false,
                                            isAddon:false,
                                            half_truck_space: 0,
                                            half_truck_price: 0.00,
                                            full_truck_space: 0,
                                            full_truck_price: 0.00,
                                            meta_title: "",
                                            meta_description: "",
                                            meta_keywords: "",
                                            canonical_url: "",
                                            robots: "",
                                            og_title: "",
                                            og_description: "",
                                            og_image: "",
                                            twitter_title: "",
                                            twitter_description: "",
                                            twitter_image: ""
                                        }}
                                        validate={(values) => {
                                            const errors = {};
                                            if (!values.title) {
                                                errors.title = "Title is required";
                                            }

                                            if (!values.isVariation) {

                                                if (!values.short_description) {
                                                    errors.short_description = "Short description is required";
                                                }
                                                if (!values.description) {
                                                    errors.description = "Description is required";
                                                }
                                                // if (!values.specification) {
                                                //     errors.specification = "Specification is required";
                                                // }

                                                if (!values.regular_price) {
                                                    errors.regular_price = "Regular price is required";
                                                } else if (isNaN(values.regular_price)) {
                                                    errors.regular_price = "Regular price is number or decimal value";
                                                }

                                                if (!values.sale_price) {
                                                    errors.sale_price = "Sale price is required";
                                                } else if (isNaN(values.sale_price)) {
                                                    errors.sale_price = "Sale price is number or decimal value";
                                                }

                                                if (!values.sku) {
                                                    errors.sku = "SKU is required";
                                                }
                                                if (!values.stock) {
                                                    errors.stock = "Stock is required";
                                                }
                                            }

                                            if (!values.product_image) {
                                                errors.product_image = "Product image is required";
                                            }

                                            return errors;
                                        }}
                                        onSubmit={handleSubmit}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                            setFieldValue,
                                        }) => {
                                            const handleSelectImage = (image) => {
                                                setProductThumb(image);
                                                setShowMedia(false);
                                                setFieldValue("product_image", image.id); // safe now
                                            };

                                            return (
                                                <form onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className={`col-md-8`}>
                                                            <div className="form-group">
                                                                <label>Product Title</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="title"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.title}
                                                                />
                                                                {errors.title && touched.title && (
                                                                    <span className="help-error">{errors.title}</span>
                                                                )}
                                                            </div>
                                                            <div className="form-group row pd-10">
                                                                <div className="form-check-custom col-md-4 mt-0">
                                                                    {/* <input type="checkbox" value={values.isVariation} id="isVariation" name="isVariation" onChange={handleChange}
                                                                    onBlur={handleBlur} /> */}
                                                                    <input
                                                                        type="checkbox"
                                                                        id="isVariation"
                                                                        name="isVariation"
                                                                        checked={values.isVariation}
                                                                        onChange={() => {
                                                                            setFieldValue("isVariation", !values.isVariation)
                                                                            setFieldValue("variation_image", !values.variation_image);
                                                                        }}
                                                                    />
                                                                    <label htmlFor="isVariation">
                                                                        Variable Product
                                                                    </label>
                                                                </div>
                                                                {values.isVariation && <div className="form-check-custom mt-0 col-md-4">
                                                                    <input type="checkbox" id="variation_image" name="variation_image" checked={values.variation_image}
                                                                        onChange={() => setFieldValue("variation_image", !values.variation_image)} />
                                                                    <label htmlFor="variation_image">
                                                                        Variation Wise Image
                                                                    </label>
                                                                </div>}
                                                                <div className="form-check-custom col-md-4 mt-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="isBulk"
                                                                        name="isBulk"
                                                                        checked={values.isBulk}
                                                                        onChange={() => {
                                                                            setFieldValue("isBulk", !values.isBulk)
                                                                        }}
                                                                    />
                                                                    <label htmlFor="isBulk">
                                                                        isBulk
                                                                    </label>
                                                                </div>
                                                                 <div className="form-check-custom col-md-4 mt-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="isAddon"
                                                                        name="isAddon"
                                                                        checked={values.isAddon}
                                                                        onChange={() => {
                                                                            setFieldValue("isAddon", !values.isAddon)
                                                                        }}
                                                                    />
                                                                    <label htmlFor="isAddon">
                                                                        isAddon
                                                                    </label>
                                                                </div>


                                                            </div>
                                                            <div className="form-group">
                                                                <label>Short description</label>
                                                                <Field
                                                                    name="short_description">
                                                                    {({ field, form }) => (
                                                                        <CKEditorField field={field} form={form} />
                                                                    )}
                                                                </Field>


                                                                {errors.short_description &&
                                                                    touched.short_description && (
                                                                        <span className="help-error">
                                                                            {errors.short_description}
                                                                        </span>
                                                                    )}
                                                            </div>
                                                            {
                                                                !values.isVariation && <>

                                                                    <div className="form-group">
                                                                        <label>Description</label>
                                                                        <Field name="description">
                                                                            {({ field, form }) => (
                                                                                <CKEditorField field={field} form={form} />
                                                                            )}
                                                                        </Field>

                                                                        {errors.description && touched.description && (
                                                                            <span className="help-error">
                                                                                {errors.description}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    {/* <div className="form-group">
                                                            <label>Product Specification</label>
                                                            <Field name="specification">
                                                                {({ field, form }) => (
                                                                    <CKEditorField field={field} form={form} />
                                                                )}
                                                            </Field>
                                                            {errors.specification && touched.specification && (
                                                                <span className="help-error">
                                                                    {errors.specification}
                                                                </span>
                                                            )}
                                                        </div> */}
                                                                </>
                                                            }

                                                        </div>
                                                        <div className={`col-md-4`}>
                                                            <div className="form-group">
                                                                <label>Product Thumbnail</label>
                                                                <div className="dropzone-box">

                                                                    {
                                                                        product_thumb !== '' && <img src={product_thumb.path} alt="product_thumbnail" />
                                                                    }
                                                                    {
                                                                        product_thumb !== '' ? <button type="button" className="floatBtn" onClick={() => setShowMedia(true)}><FiEdit size={15} /></button> : <>
                                                                            {/* <p>Drop files to upload</p>
                                                                        <p>or</p> */}
                                                                            <button type="button" onClick={() => setShowMedia(true)} className="choose-btn">Choose file</button>
                                                                        </>
                                                                    }
                                                                </div>


                                                                {errors.product_image && touched.product_image && (
                                                                    <span className="help-error">
                                                                        {errors.product_image}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {
                                                                !values.isVariation && <>

                                                                    <div className="form-group row">
                                                                        <div className="col-md-6">
                                                                            <label>Regular Price</label>
                                                                            <div className="priceBox">
                                                                                <div className="priceIcon">£</div>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    name="regular_price"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.regular_price}
                                                                                    placeholder="0.00"
                                                                                />
                                                                            </div>

                                                                            {errors.regular_price && touched.regular_price && (
                                                                                <span className="help-error">
                                                                                    {errors.regular_price}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <label>Sale Price</label>
                                                                            <div className="priceBox">
                                                                                <div className="priceIcon">£</div>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    name="sale_price"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.sale_price}
                                                                                    placeholder="0.00"
                                                                                />
                                                                            </div>
                                                                            {errors.sale_price && touched.sale_price && (
                                                                                <span className="help-error">
                                                                                    {errors.sale_price}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {
                                                                        values.isBulk && <div className="form-group row">
                                                                            <div className="col-md-6 mb-3">
                                                                                <label>Half Truck Space</label>
                                                                                <div className="priceBox">

                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        name="half_truck_space"
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.half_truck_space}
                                                                                        placeholder="1,2 etc"
                                                                                    />
                                                                                </div>

                                                                                {errors.half_truck_space && touched.half_truck_space && (
                                                                                    <span className="help-error">
                                                                                        {errors.half_truck_space}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <label>Half Truck Price</label>
                                                                                <div className="priceBox">
                                                                                    <div className="priceIcon">£</div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        name="half_truck_price"
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.half_truck_price}
                                                                                        placeholder="0.00"
                                                                                    />
                                                                                </div>

                                                                                {errors.half_truck_price && touched.half_truck_price && (
                                                                                    <span className="help-error">
                                                                                        {errors.half_truck_price}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <label>Full Truck Space</label>
                                                                                <div className="priceBox">

                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        name="full_truck_space"
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.full_truck_space}
                                                                                        placeholder="1,2 etc"
                                                                                    />
                                                                                </div>

                                                                                {errors.full_truck_space && touched.full_truck_space && (
                                                                                    <span className="help-error">
                                                                                        {errors.full_truck_space}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <label>Full Truck Price</label>
                                                                                <div className="priceBox">
                                                                                    <div className="priceIcon">£</div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        name="full_truck_price"
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.full_truck_price}
                                                                                        placeholder="0.00"
                                                                                    />
                                                                                </div>
                                                                                {errors.full_truck_price && touched.full_truck_price && (
                                                                                    <span className="help-error">
                                                                                        {errors.full_truck_price}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    }




                                                                    <div className="form-group row">
                                                                        <div className="col-md-6">
                                                                            <label>SKU</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="sku"
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                value={values.sku}
                                                                            />
                                                                            {errors.sku && touched.sku && (
                                                                                <span className="help-error">{errors.sku}</span>
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <label>Total Stock</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="stock"
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                value={values.stock}
                                                                            />
                                                                            {errors.stock && touched.stock && (
                                                                                <span className="help-error">{errors.stock}</span>
                                                                            )}
                                                                        </div>

                                                                    </div>
                                                                </>
                                                            }


                                                            <div className="form-group row">
                                                                <div className="col-md-6">
                                                                    <label>Tax Status</label>
                                                                    <select className="form-control" name="tax_status" onChange={handleChange}
                                                                        onBlur={handleBlur} value={values.tax_status}>
                                                                        <option value={0}>No</option>
                                                                        <option value={1}>Yes</option>
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-6">

                                                                    <div className="form-check-custom">
                                                                        <input type="checkbox" value={values.best_seller} id="best_sale" name="best_seller" onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                        <label htmlFor="best_sale">
                                                                            Best Saller
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group row">
                                                                <div className="col-md-6">
                                                                    <div className="form-check-custom" style={{ marginTop: 0 }}>
                                                                        <input type="checkbox" value={values.featured_product} id="featured_product" name="featured_product" onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                        <label htmlFor="featured_product">
                                                                            Featured Product
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                              
                                                            </div>

                                                            <div className="form-group">
                                                                <label>Flavors</label>
                                                                <Field name="flavor">
                                                                    {({ field, form }) => (
                                                                        <Select
                                                                            {...field}
                                                                            value={flavors.find(
                                                                                (option) => option.value === form.values.flavor
                                                                            )}
                                                                            onChange={(selectedOption) =>
                                                                                form.setFieldValue("flavor", selectedOption.value)
                                                                            }
                                                                            options={flavors}
                                                                            placeholder="Select flavor"
                                                                            className="select2"
                                                                        />
                                                                    )}
                                                                </Field>

                                                            </div>
                                                            <div className="form-group">
                                                                <label>Categories</label>
                                                                <Field name="categories">
                                                                    {({ field }) => (
                                                                        <Select
                                                                            {...field}
                                                                            value={categoryOptions.filter((option) =>
                                                                                values.categories.includes(option.value)
                                                                            )}
                                                                            onChange={(selectedOptions) =>
                                                                                setFieldValue(
                                                                                    "categories",
                                                                                    selectedOptions.map(
                                                                                        (option) => option.value
                                                                                    )
                                                                                )
                                                                            }
                                                                            options={categoryOptions}
                                                                            placeholder="Select categories"
                                                                            isMulti
                                                                            className="select2"
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </div>

                                                            <div className="form-group">
                                                                <label>Status</label>
                                                                <select className="form-control" name="status" onChange={handleChange}
                                                                    onBlur={handleBlur} value={values.status}>
                                                                    <option value={1}>Published</option>
                                                                    <option value={0}>Draft</option>
                                                                </select>
                                                            </div>
                                                            <div className="sbt-product">
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary btn-block"
                                                                    disabled={isSubmitting}
                                                                >
                                                                    {isSubmitting ? "Please wait..." : "Save"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card" style={{ marginTop: 20 }}>
                                                        <div className="card-header">
                                                            <h3>Search Engine Optimization</h3>
                                                        </div>
                                                        <div className="card-body">
                                                            <div class="mb-3">
                                                                <label for="metaTitle" class="form-label">Meta Title</label>
                                                                <input type="text" class="form-control" id="metaTitle" name="meta_title" placeholder="Enter meta title"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.meta_title}
                                                                />
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="metaDescription" class="form-label">Meta Description</label>
                                                                <textarea class="form-control" id="metaDescription" name="meta_description" rows="3" placeholder="Enter meta description" onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.meta_description}></textarea>
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="metaKeywords" class="form-label">Meta Keywords</label>
                                                                <input type="text" class="form-control" id="metaKeywords" name="meta_keywords" placeholder="e.g. electronics, gadgets, accessories" onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.meta_keywords} />
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="canonicalUrl" class="form-label">Canonical URL</label>
                                                                <input type="text" class="form-control" id="canonicalUrl" name="canonical_url" placeholder="https://example.com/category" onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.canonical_url} />
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="robots" class="form-label">Robots</label>
                                                                <input type="text" class="form-control" id="robots" name="robots" placeholder="index, follow" onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.robots} />
                                                            </div>
                                                            <hr />
                                                            <h5 style={{ marginBottom: 10 }}>Open Graph (Facebook)</h5>
                                                            <div class="mb-3">
                                                                <label for="ogTitle" class="form-label">OG Title</label>
                                                                <input type="text" class="form-control" id="ogTitle" name="og_title" placeholder="Enter OG title" onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.og_title} />
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="ogDescription" class="form-label">OG Description</label>
                                                                <textarea class="form-control" id="ogDescription" name="og_description" rows="3" placeholder="Enter OG description"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.og_description}
                                                                ></textarea>
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="ogImage" class="form-label">OG Image URL</label>
                                                                <input type="text" class="form-control" id="ogImage" name="og_image" placeholder="https://example.com/image.jpg"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.og_image}
                                                                />
                                                            </div>
                                                            <hr />
                                                            <h5 style={{ marginBottom: 10 }}>Twitter Card</h5>
                                                            <div class="mb-3">
                                                                <label for="twitterTitle" class="form-label">Twitter Title</label>
                                                                <input type="text" class="form-control" id="twitterTitle" name="twitter_title" placeholder="Enter Twitter title"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.twitter_title}
                                                                />
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="twitterDescription" class="form-label">Twitter Description</label>
                                                                <textarea class="form-control" id="twitterDescription" name="twitter_description" rows="3" placeholder="Enter Twitter description" onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.twitter_description}></textarea>
                                                            </div>
                                                            <div class="mb-3">
                                                                <label for="twitterImage" class="form-label">Twitter Image URL</label>
                                                                <input type="text" class="form-control" id="twitterImage" name="twitter_image" placeholder="https://example.com/twitter-image.jpg" onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.twitter_image} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        showMedia && <MediaLibraryPopup isMulti={false} show={showMedia} setShowMedia={setShowMedia} handleImageSubmit={handleSelectImage} setFieldValue={setFieldValue} fieldName="product_image" />
                                                    }
                                                </form>
                                            );
                                        }}
                                    </Formik>
                                </Tab>
                                <Tab eventKey="variations" title="Variations" disabled>
                                    Variations
                                </Tab>
                                <Tab eventKey="specification" title="Specification" disabled>
                                    specification
                                </Tab>
                                <Tab eventKey="other_details" title="Images & Videos" disabled>
                                    Images & Videos
                                </Tab>
                            </Tabs>



                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateProduct;
